"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.default = () => {
    const [isOffline, setIsOffline] = (0, react_1.useState)(!window.navigator.onLine);
    (0, react_1.useEffect)(() => {
        const wentOffline = () => {
            setIsOffline(true);
        };
        const wentOnline = () => {
            setIsOffline(false);
        };
        window.addEventListener("offline", wentOffline);
        window.addEventListener("online", wentOnline);
        return () => {
            window.removeEventListener("offline", wentOffline);
            window.removeEventListener("online", wentOnline);
        };
    }, []);
    return { isOffline };
};
//# sourceMappingURL=useNetwork.js.map